import React, { useState } from "react";
import Button from "@material-ui/core/Button";

import PrintParameters from "@arcgis/core/rest/support/PrintParameters";
import PrintTemplate from "@arcgis/core/rest/support/PrintTemplate";
import * as print from "@arcgis/core/rest/print";

const Print = (props) => {
  const [printUrl, setPrintUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const handleClick = async (event) => {
    if (props.view) {
      let pp;
      let pt;
      let tmplt;

      if (window.screen.width > window.screen.height) {
        // Resolution is 1024x768 or above
        tmplt = new PrintTemplate({
          format: "pdf",
          exportOptions: { dpi: 300 },
          layout: "a4-landscape",
          layoutOptions: { titleText: "Ohio Trails Explorer" },
        });
      } else {
        tmplt = new PrintTemplate({
          format: "pdf",
          exportOptions: { dpi: 300 },
          layout: "a4-portrait",
          layoutOptions: { titleText: "Ohio Trails Explorer" },
        });
      }

      pp = new PrintParameters({ view: props.view, template: tmplt });

      setLoading(true);
      print
        .execute(
          "https://gis.ohiodnr.gov/arcgis/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task",
          pp
        )
        .then((result) => {
          setPrintUrl(result.url);
          setLoading(false);
          setError(false);
        })
        .catch((e) => {
          setError(true);
        });
    }
  };

  const redo = () => {
    setPrintUrl(null);
    setLoading(false);
    setError(false);
  };

  const printBtnStyle = {
    display: "block",
    width: "100px",
    backgroundColor: "#4D7343",
    color: "white",
  };

  const redoBtnStyle = {
    display: "block",
    width: "100px",
    backgroundColor: "#1C0A86",
  };

  const errorBtnStyle = {
    display: "block",
    width: "100px",
    backgroundColor: "#DF0B04",
    color: "white",
  };

  return (
    <>
      {error ? (
        <>
          <Button
            aria-describedby={"open-pdf-btn"}
            variant="contained"
            color="secondary"
            style={errorBtnStyle}
            disabled
          >
            Error
          </Button>
          <Button
            aria-describedby={"open-pdf-btn"}
            variant="contained"
            color="secondary"
            onClick={redo}
            style={redoBtnStyle}
          >
            Redo
          </Button>
        </>
      ) : !printUrl ? (
        loading ? (
          <Button
            aria-describedby={"printing-btn"}
            variant="contained"
            color="secondary"
            onClick={handleClick}
            style={printBtnStyle}
            disabled
          >
            Printing...
          </Button>
        ) : (
          <Button
            aria-describedby={"print-btn"}
            variant="contained"
            color="secondary"
            onClick={handleClick}
            style={printBtnStyle}
          >
            Print
          </Button>
        )
      ) : (
        <>
          <Button
            aria-describedby={"open-pdf-btn"}
            variant="contained"
            color="secondary"
            onClick={() => window.open(printUrl, "_blank")}
            style={printBtnStyle}
          >
            Open
          </Button>
          <Button
            aria-describedby={"open-pdf-btn"}
            variant="contained"
            color="secondary"
            onClick={redo}
            style={redoBtnStyle}
          >
            Redo
          </Button>
        </>
      )}
    </>
  );
};

export default Print;
